import React, { useEffect, useState } from 'react';
// import DateCurrent from './DateCurrent';
import logo from './images/SuperSeva_Logo_white.png'
import './navbar_not_login.css';
import email from './images/email.png'
import smartphonecall from './images/smartphonecall.png'
import image3 from './images/21440194611594721608.png';
import unacadamy_logo from './images/unacadamy_logo.png'
import {Button} from 'react-bootstrap';
import {useHistory} from 'react-router-dom';
import axios from 'axios';
import { Link, NavLink } from 'react-router-dom';

function Navbar_Not_Login(props) {
    const history=useHistory()
    const checkActive = (match, location) => {
        //some additional logic to verify you are in the home URI
        if(!location) return false;
        const {pathname} = location;
        console.log(pathname);
        return pathname === "/";
    }
  return (
    <div style={{
        backgroundColor:'#00172d', height:200
    }}>
    <div style={{display:'flex', flexDirection:'row', padding:10}}>
        <div style={{width:20}}></div>
        <div>
            <img src={email} style={{height:20,filter: 'brightness(0) invert(1)'}}/>
            <a href = "mailto: sales@superseva.com" target='_blank' style={{paddingLeft:10, color:'#fff'}}>sales@superseva.com </a>
        </div>
        <div style={{width:20}}></div>
        <div>
            <img src={smartphonecall} style={{height:20, filter: 'brightness(0) invert(1)'}}/>
            <a href="tel:+91 7339125788" style={{paddingLeft:10, color:'#fff'}}>+91 9590901901</a>
        </div>
    </div>

    <div className="Navbar flex-container" style={{
        marginRight:10,
        marginLeft:10
    }}>
        <div style={{
            width:'40%'
        }}>
                <a className="navbar-brand" href="/">
                <img src={logo} 
                alt="SuperSeva.png" 
                className="superseva-logo" 
                width="65%" 
                />
                </a>
        </div>
        <div style={{
            width:'60%',
            display:'flex',
            justifyContent:'space-around',
            alignItems:'center',
            textAlign:'center'
        }}>
            <ul style={{
                width:'100%',
                flexDirection:'row', 
                display:'flex',
                justifyContent:'space-around',
                alignItems:'center'
            }}>
                <li>
                    <NavLink isActive={checkActive} onClick={()=>{
                        axios.get('/currentuser')
                        .then(res=>{
                            if(res.data.error){
        
                            }else{   
                                history.replace("/");
                                history.go(0)
                            }
                        })
                    }} style={{
                        textDecoration:'none', fontWeight:'bold',
                        color:'#00172d'
                    }}  activeStyle={{ color: "orange" }} to='/'>HOME</NavLink>
                </li>
                <li>
                    <NavLink onClick={()=>{
                        axios.get('/currentuser')
                        .then(res=>{
                            if(res.data.error){
        
                            }else{   
                                history.replace("/");
                                history.go(0)
                            }
                        })
                    }} style={{
                        textDecoration:'none', fontWeight:'bold',
                        color:'#00172d'
                    }} activeStyle={{ color: "orange" }} to='/about'>ABOUT</NavLink>
                </li>
                <li>
                    <NavLink onClick={()=>{
                        axios.get('/currentuser')
                        .then(res=>{
                            if(res.data.error){
        
                            }else{ 
                                history.replace("/");  
                                history.go(0)
                            }
                        })
                    }} style={{
                        textDecoration:'none', fontWeight:'bold',
                        color:'#00172d'
                    }} activeStyle={{ color: "orange" }} to='/contact'>CONTACT</NavLink>
                </li>
                <li>
                    <NavLink onClick={()=>{
                        axios.get('/currentuser')
                        .then(res=>{
                            if(res.data.error){
        
                            }else{   
                                history.replace("/");
                                history.go(0)
                            }
                        })
                    }} style={{
                        textDecoration:'none', fontWeight:'bold',
                        color:'#00172d'
                    }} activeStyle={{ color: "orange" }} to='/login'>LOG IN</NavLink>
                </li>
                <li>
                    <NavLink onClick={()=>{
                        axios.get('/currentuser')
                        .then(res=>{
                            if(res.data.error){
        
                            }else{   
                                history.replace("/");
                                history.go(0)
                            }
                        })
                    }} style={{
                        textDecoration:'none', fontWeight:'bold',
                        color:'#00172d'
                    }} activeStyle={{ color: "orange" }} to='/signup'>SIGN UP</NavLink>
                </li>
            </ul>
        
        </div>
    </div>
    </div>
  );
}

export default Navbar_Not_Login;
